import { render, staticRenderFns } from "./AtividadesGestor.vue?vue&type=template&id=d73dc394"
import script from "./AtividadesGestor.vue?vue&type=script&lang=js"
export * from "./AtividadesGestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports